import request from '@/utils/request'
import allRoutes from '@/router/allRoutes'
import staticRoutes from '@/router/staticRoutes'
import { getToken, setToken, removeToken, getStorge, setStorge, removeStorge } from '@/utils/auth'
import Layout from '@/components/WtLayout/WtLayout'
import WtContainer from '@/components/WtLayout/WtContainer'

function handleModuleMap(moduleItem, moduleResultMap) {
  const moduleId = moduleItem.moduleId
  if (moduleResultMap[moduleId] != null && moduleResultMap[moduleId].length > 0) {
    moduleItem.children = moduleItem.children || []
    moduleResultMap[moduleId].forEach((item) => {
      handleModuleMap(item, moduleResultMap)
      moduleItem.children.push(item)
    })
  }
}

const auth = {
  state: {
    token: getToken(),
    permissionCodes: [],
    userInfo: getStorge('UserInfo'),
    name: getStorge('UserName'),
    realname: getStorge('UserRealName'),
    userId: getStorge('UserId'),
    userUuid: getStorge('UserUuid'),
    userDuty: getStorge('UserDuty'),
    avatar: '',
    moduleItem: {},
    moduleList: [],
    moduleMap: {},
    isDynamicRoutesInit: false,
    dynamicRoutes: [],
    messageMap: {}, // 气泡
    setRoleList: [], // 当前用户权限
    roles: [],
    tabList: [],
    currentTab: '',
    isAccountDetailLoading: false,
    accountDetailData: {},
    isRoleDetailLoading: false,
    roleDetailData: {},
    roleModuleListMap: {},
    rolePermissionListMap: {},
    isModuleDetailLoading: false,
    moduleDetailData: {},
    organizationDetailData: {},
    isPermissionDetailLoading: false,
    permissionDetailData: {},
    currentRoute: '',
    currentSystem: 'systemA' // 当前系统标识：systemA（回收管家）或 systemB（爱博绿）
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_MODULE_ITEM: (state, moduleItem) => {
      state.moduleItem = moduleItem
    },
    SET_MODULE_LIST: (state, moduleList) => {
      state.moduleList = moduleList
      if (moduleList && moduleList.length > 0) {
        state.moduleItem = moduleList[0]
      }
    },
    SET_MESSAGE_MAP: (state, data) => {
      state.messageMap = Object.assign({}, state.messageMap, data)
    },
    SET_MODULE_MAP: (state, moduleMap) => {
      state.moduleMap = moduleMap
    },
    SET_DYNAMIC_ROUTES: (state, dynamicRoutes) => {
      state.dynamicRoutes = dynamicRoutes
      state.isDynamicRoutesInit = true
    },
    SET_PERMISSION_CODES: (state, data) => {
      // setStorgeItem('permissionCodes', data)
      state.permissionCodes = data
    },
    SET_USERINFO: (state, data) => {
      setStorge('UserName', data.accountResult.username)
      setStorge('UserRealName', data.accountResult.realname)
      setStorge('UserId', data.accountResult.id)
      setStorge('UserUuid', data.accountResult.uuid)
      setStorge('UserDuty', data.accountResult.duty)
      setStorge('UserInfo', data)
      state.userInfo = data
      state.userId = data.accountResult.id
      state.name = data.accountResult.username
      state.realname = data.accountResult.realname
      state.userDuty = data.accountResult.duty
    },
    SET_IS_MODULES_ACCOUNT_DETAIL_LOADING: (state, data) => {
      state.isAccountDetailLoading = data
    },
    SET_MODULES_ACCOUNT_DETAIL_DATA: (state, data) => {
      state.accountDetailData = data
    },
    SET_IS_MODULES_ROLE_DETAIL_LOADING: (state, data) => {
      state.isRoleDetailLoading = data
    },
    SET_MODULES_ROLE_DETAIL_DATA: (state, data) => {
      state.roleDetailData = data
    },
    SET_ROLE_MODULE_LIST_MAP: (state, data) => {
      state.roleModuleListMap = data.roleModuleListMap
      state.rolePermissionListMap = data.rolePermissionListMap
    },
    SET_IS_MODULE_DETAIL_LOADING: (state, data) => {
      state.isModuleDetailLoading = data
    },
    SET_MODULE_DETAIL_DATA: (state, data) => {
      state.moduleDetailData = data
    },
    SET_IS_PERMISSION_DETAIL_LOADING: (state, data) => {
      state.isPermissionDetailLoading = data
    },
    SET_PERMISSION_DETAIL_DATA: (state, data) => {
      state.permissionDetailData = data
    },
    SET_ORGANIZATION_DETAIL_DATA: (state, data) => {
      state.organizationDetailData = data
    },
    SET_CURRENT_ROUTE: (state, data) => {
      state.currentRoute = data
    },
    SET_CURRENT_ROLE_LIST: (state, data) => {
      state.setRoleList = data
    },
    SET_CURRENT_SYSTEM: (state, data) => {
      state.currentSystem = data
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/auth/login',
          method: 'post',
          data: {
            'username': username,
            'password': userInfo.password
          }
        }).then(response => {
          const data = response.data
          setToken(data.token)
          commit('SET_TOKEN', data.token)
          commit('SET_USERINFO', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户菜单权限
    requestDynamicRoutes({ commit, state }) {
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/auth/authInfo',
          method: 'post',
          data: { }
        }).then(response => {
          const resultDatas = []
          const tempDatas = []
          const moduleResultList = response.data.moduleResultList
          const moduleResultMap = {}
          if (moduleResultList !== null && moduleResultList.length > 0) {
            moduleResultList.forEach((item) => {
              const moduleUrl = item.moduleUrl
              const moduleName = item.moduleName
              const moduleParentId = item.moduleParentId
              const moduleId = item.id
              const moduleCode = item.moduleCode
              // 根据模块code判断所属系统
              let systemCode = 'systemA' // 默认系统A：回收管家
              // 在爱博绿系统显示的模块列表，可以在这里添加更多需要在爱博绿显示的模块
              const systemBModules = [
                'MODULE_WORKBENCH_LIST',
                'MODULE_BOX_TRANSPORTATION_LIST',
                'MODULE_DELIVER_BOX_LIST',
                'MODULE_VIOLATION_LIST',
                'MODULE_TRANSPORTATION_LIST',
                'MODULE_DELIVERY_RECORD_LIST',
                'MODULE_RECYCLINGBIN_LIST',
                'MODULE_DECLINE_LIST',
                'MODULE_RECYCLINGBINLOG_LIST',
                'MODULE_RECYCLINGMONEY_LIST',
                'MODULE_USER_MANAGEMENT_LIST',
                'MODULE_USER_FINANCE_LIST',
                'MODULE_DAILY_COMPANY_LIST'
              ]
              if (systemBModules.includes(moduleCode)) {
                systemCode = 'systemB' // 系统B：爱博绿
              }
              if (moduleParentId === 1) {
                tempDatas.push({
                  moduleId: moduleId,
                  path: '/' + moduleUrl,
                  component: Layout,
                  name: moduleName,
                  meta: { title: moduleName, icon: '', systemCode: systemCode },
                  children: []
                })
              } else {
                if (moduleResultMap[moduleParentId] == null) {
                  moduleResultMap[moduleParentId] = []
                }
                const tempModule = Object.assign({
                  moduleId: moduleId,
                  path: moduleUrl,
                  name: moduleUrl,
                  meta: { title: moduleName, icon: '', systemCode: systemCode }
                }, allRoutes[moduleCode])
                tempModule.component = tempModule.component || WtContainer
                moduleResultMap[moduleParentId].push(tempModule)
              }
            })
            //  测试
            tempDatas.forEach((topModuleItem) => {
              handleModuleMap(topModuleItem, moduleResultMap)
              resultDatas.push(topModuleItem)
            })
          }
          //  添加静态配置，生产环境需要去掉
          if (staticRoutes.length > 0 && staticRoutes.length > 0) {
            staticRoutes.forEach((item) => {
              if (item.isSingle) {
                resultDatas.push(item)
              } else {
                resultDatas[0].children.push(item)
              }
            })
          }
          // TODO 消息气泡
          // commit('SET_MESSAGE_MAP', { '审计发现': 2, '指定任务负责人': 3 })
          // console.log('resultDatas', resultDatas)
          // console.log('moduleResultMap', moduleResultMap)
          if (tempDatas && tempDatas.length > 0) {
            const redirectUrl = tempDatas[0].path + '/' + tempDatas[0].children[0].path + '/' + tempDatas[0].children[0].children[0].path
            resultDatas.push({ path: '/', redirect: redirectUrl, hidden: true })
          }
          resultDatas.push({ path: '*', redirect: '/404', hidden: true })
          commit('SET_MODULE_MAP', moduleResultMap)
          commit('SET_MODULE_LIST', tempDatas)
          commit('SET_DYNAMIC_ROUTES', resultDatas)
          commit('SET_PERMISSION_CODES', response.data.permissionSet)
          commit('SET_CURRENT_ROLE_LIST', response.data.roleSet)
          resolve(resultDatas)
        }).catch(error => {
          commit('SET_DYNAMIC_ROUTES', [])
          commit('SET_PERMISSION_CODES', [])
          reject(error)
        })
      })
    },
    updateMessageCount({ commit }, data) {
      commit('SET_MESSAGE_MAP', data)
    },
    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        request({
          url: '/user/info',
          method: 'get',
          params: { 'token': state.token }
        }).then(response => {
          const data = response.data
          commit('SET_ROLES', data.roles)
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        removeStorge('UserName')
        resolve()
      })
    },
    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },
    //  获取账号编辑页面数据
    queryAccountDetailData({ commit }, id) {
      commit('SET_IS_MODULES_ACCOUNT_DETAIL_LOADING', true)
      commit('SET_MODULES_ACCOUNT_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/auth/accountDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_ACCOUNT_DETAIL_LOADING', false)
          if (!response.data.photo) {
            response.data.photo = '';
          }
          response.data.password = '';
          response.data.newPassword = '';
          response.data.confirmPassword = '';
          commit('SET_MODULES_ACCOUNT_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_ACCOUNT_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetAccountDetailData({ commit }) {
      commit('SET_MODULES_ACCOUNT_DETAIL_DATA', {})
    },
    //  获取账号编辑页面数据
    queryRoleDetailData({ commit }, id) {
      commit('SET_IS_MODULES_ROLE_DETAIL_LOADING', true)
      commit('SET_MODULES_ROLE_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/auth/roleDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_ROLE_DETAIL_LOADING', false)
          commit('SET_MODULES_ROLE_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_ROLE_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置角色新增页面数据
    resetRoleDetailData({ commit }) {
      commit('SET_MODULES_ROLE_DETAIL_DATA', { permissionList: [] })
    },
    //  角色管理页面获取系统中全部可用模块
    queryRoleModuleListMap({ commit }) {
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/auth/roleModuleList',
          method: 'post',
          data: {}
        }).then(response => {
          //  模块列表组
          const tempModuleMap = {}
          response.data.moduleResultList.forEach((item) => {
            if (tempModuleMap[item.moduleParentId + ''] === null || tempModuleMap[item.moduleParentId + ''] === undefined) {
              tempModuleMap[item.moduleParentId + ''] = []
            }
            tempModuleMap[item.moduleParentId + ''].push(item)
          })
          //  权限列表组
          const tempPermissionMap = {}
          response.data.permissionResultList.forEach((item) => {
            if (tempPermissionMap[item.moduleId + ''] === null || tempPermissionMap[item.moduleId + ''] === undefined) {
              tempPermissionMap[item.moduleId + ''] = []
            }
            tempPermissionMap[item.moduleId + ''].push(item)
          })
          commit('SET_ROLE_MODULE_LIST_MAP', { roleModuleListMap: tempModuleMap, rolePermissionListMap: tempPermissionMap })
        }).catch(error => {
          commit('SET_ROLE_MODULE_LIST_MAP', {})
          reject(error)
        })
      })
    },
    //  获取账号编辑页面数据
    queryModuleDetailData({ commit }, id) {
      commit('SET_IS_MODULE_DETAIL_LOADING', true)
      commit('SET_MODULE_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/auth/moduleDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULE_DETAIL_LOADING', false)
          commit('SET_MODULE_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULE_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置角色新增页面数据
    resetModuleDetailData({ commit }) {
      commit('SET_MODULE_DETAIL_DATA', { permissionList: [] })
    },
    //  获取权限编辑页面数据
    queryPermissionDetailData({ commit }, id) {
      commit('SET_IS_PERMISSION_DETAIL_LOADING', true)
      commit('SET_PERMISSION_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/auth/permissionDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_PERMISSION_DETAIL_LOADING', false)
          commit('SET_PERMISSION_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_PERMISSION_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置权限新增页面数据
    resetPermissionDetailData({ commit }, data) {
      console.log('data', data)
      commit('SET_PERMISSION_DETAIL_DATA', Object.assign({}, data))
    },
    // 设置的默认模块
    updateModuleItem: ({ commit }, data) => {
      commit('SET_MODULE_ITEM', data)
    },
    // 切换当前系统
    switchSystem: ({ commit }, systemCode) => {
      commit('SET_CURRENT_SYSTEM', systemCode)
    },
    // 重置机构管理新增页面数据
    queryAddOrganizationDetailData({ commit }) {
      commit('SET_ORGANIZATION_DETAIL_DATA', { permissionList: [] })
    }
  }
}

export default auth
